import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { Tabs } from 'module-tsl-ui-elements';
import WithDocgen from 'module-tsl-ui-elements/with-docs/tabs/Tabs';
import pkg from 'module-tsl-ui-elements/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`class ControlledTabs extends React.Component {
    constructor(props) {
      super(props);
      this.state = { tab: 0 };
    }
    render() {
      return (
        <div className="tes-js" style={{ padding: 10 }}>
          <Tabs
            content={[
              {
                label: 'tab 1',
                body: <div>body 1</div>,
              },
              {
                label: 'tab 2',
                body: <div>body 2</div>,
              },
              {
                label: 'tab 3',
                body: <div>body 3</div>,
              }
            ]}
            activeTab={this.state.tab}
            onActivate={(tab, idx) => this.setState({ tab: idx })}
          />
        </div>
      );
    }
  }
`}
  scope={ { Tabs } }
/>
<MDXTag name="h3" components={components} props={{"id":"example-with-links-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-with-links-editable","aria-label":"example with links editable permalink","class":"anchor"}}></MDXTag>{`example with links (editable)`}</MDXTag>
<MDXTag name="p" components={components}>{`You can also specify the `}<code className="language-text">href</code>
{` and `}<code className="language-text">target</code>
{` on the content object so you will have a tab as link.`}</MDXTag>
<MDXTag name="p" components={components}>{`Try changing `}<code className="language-text">defaultActiveTab</code>
{` to see the active one.`}</MDXTag>
<LiveCode
  code={`class TabsLinks extends React.Component {
    render() {
      return (
        <div className="tes-js" style={{ padding: 10 }}>
          <Tabs
            content={[
              {
                label: 'To google.com',
                href: 'https://google.com/',
              },
              {
                label: 'To tes.com',
                href: 'https://www.tes.com',
              },
              {
                label: 'To a new tab',
                href: 'https://www.tes.com',
                target: '_blank',
              }
            ]}
            defaultActiveTab={0}
          />
        </div>
      );
    }
  }
`}
  scope={ { Tabs } }
/>
<PropsTable data={WithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-elements --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  